// reducers.js
import { START_LOADING, END_LOADING } from "./appActions";

const initialState = {
  isLoading: false,
  loadingText: "",
  loadingSubText: "",
  darkMode: true,
  error: "",
  pageTitle: "",
  showCallModal: false,
  showAddDealModal: false,
  videoTour: false,
  introCompletion: 0,
  stages: [],
  selectedPersona: null,
};

const appReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false, loadingText: "", loadingSubText: "" };
    case "SET_DARK_MODE":
      return {
        ...state,
        darkMode: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.value,
      };
    case "SET_PAGE_TITLE":
      return {
        ...state,
        pageTitle: action.value,
      };
    case "SET_LOADING_TEXT":
      return {
        ...state,
        loadingText: action.value,
      };
    case "SET_LOADING_SUB_TEXT":
      return {
        ...state,
        loadingSubText: action.value,
      };
    case "SET_CALL_MODAL":
      return {
        ...state,
        showCallModal: action.value,
      };
    case "SET_STAGES":
        return {
          ...state,
          stages: action.value,
        };
    case "SET_ADD_DEAL_MODAL":
      // Stop background scrolling when modal is open
      if (action.value) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
      return {
        ...state,
        showAddDealModal: action.value,
      };
    case "SET_VIDEO_TOUR":
      return {
        ...state,
        videoTour: true,
      };
    case "CLOSE_VIDEO_TOUR":
      return {
        ...state,
        videoTour: false,
      };
    case "SET_INTRO_COMPLETION":
      return {
        ...state,
        introCompletion: action.value,
      };
    case "SET_SELECTED_PERSONA":
      return {
        ...state,
        selectedPersona: action.value,
      };
    default:
      return state;
  }
};

export default appReducer;
